import FeaturedCourse from './featured-course.query'

export default FeaturedCourse
